import { Minus, Plus } from '@myosh/icons';
import { Button, SidebarGroup, SidebarGroupLabel, Skeleton } from '@myosh/odin-components';
import { type ReactNode, useState } from 'react';

const VISIBLE_LIMIT = 10;

interface FilterGroupProps<T> {
  title: string;
  items: T[];
  isLoading: boolean;
  showAllLabel: string;
  showLessLabel: string;
  children: (item: T) => ReactNode;
}

export const FilterGroup = <T,>({
  title,
  items,
  isLoading,
  showAllLabel,
  showLessLabel,
  children,
}: FilterGroupProps<T>) => {
  const [showAll, setShowAll] = useState(false);
  const visibleItems = showAll ? items : items.slice(0, VISIBLE_LIMIT);

  return (
    <SidebarGroup role="group" aria-label={title}>
      <SidebarGroupLabel>{title}</SidebarGroupLabel>
      {isLoading ? (
        <div className="flex flex-col gap-2 px-2">
          <Skeleton className="h-5 w-3/4" />
          <Skeleton className="h-5 w-2/3" />
          <Skeleton className="h-5 w-1/2" />
        </div>
      ) : (
        <div className="flex flex-col gap-2 px-2">{visibleItems.map((item) => children(item))}</div>
      )}
      {items.length > VISIBLE_LIMIT && (
        <Button variant="link" size="xs" className="self-start" onClick={() => setShowAll(!showAll)}>
          {showAll ? <Minus data-icon="inline-start" /> : <Plus data-icon="inline-start" />}
          {showAll ? showLessLabel : showAllLabel}
        </Button>
      )}
    </SidebarGroup>
  );
};
